import type { ComponentType } from "react";
import type { ListRenameModalProps } from "../../components/modals/ListRenameModal/ListRenameModal";
import trackingService from "../../services/tracking/trackingService";

type ExpectedProps = Partial<Pick<ListRenameModalProps, "onCancel" | "onSubmit">>;

/**
 * This HoC incapsulates tracking for "cancel" & "submit" actions
 * @param RenameModalComponent
 */
export default function withListRenameModalTracking<P extends ExpectedProps>(RenameModalComponent: ComponentType<P>) {
    return function WrappedWithListRenameTracking(props: P) {
        function handleCancel() {
            trackingService.trackListRenameCancelClicked();
            props.onCancel?.();
        }

        function handleSubmit(name: string) {
            trackingService.trackListRenameSubmitClicked();
            props.onSubmit?.(name);
        }

        return (
            <RenameModalComponent
                {...props}
                onCancel={handleCancel}
                onSubmit={handleSubmit}
            />
        );
    };
}
